<div class="container-fluid h-100 d-flex justify-content-center align-items-center flex-column register-container mb-5">
  <div class="register-content register-toastr-container">
    <div class="toastr-relative toastr-sm toastr-no-shadow mb-1" toastContainer></div>
  </div>
  <ng-template #modalReset let-c="close" let-d="dismiss">
    <wsb-modal
      (primary)="modalResetForm()"
      primaryButtonText="register_passreset_submit"
      cancelButtonText="register_passreset_back"
      cancelButtonEnable="true"
      (dismiss)="d()"
      title="{{ 'register_passreset_title' | translate }}"
    >
      <div body>
        <p [innerHTML]="'register_passreset_intro' | translate"></p>
        <form [formGroup]="resetForm">
          <!--          <label for="reset_username" translate>user_username</label>-->
          <input
            type="text"
            id="reset_username"
            placeholder="{{ 'user_username' | translate }}"
            formControlName="username"
            name="username"
            class="form-control  form-control--short"
          />
          <wsb-validation-error-msg [fc]="resetForm.get('username')"></wsb-validation-error-msg>
        </form>
      </div>
    </wsb-modal>
  </ng-template>
  <div class="card card-register register-content">
    <div class="card-body px-0 py-0">
      <div class="row mx-0 my-0">
        <div class="col-12 col-lg-3 py-3 col-registration-banner">
          <div class="mb-3">
            <img *ngIf="domain?.logoUrl" class="navbar-brand__img-l register-logo" [attr.src]="domain?.logoUrl" alt="Brand Logo" />
            <p class="mt-3" [ngClass]="{ 'd-none d-md-block': registrationStep > 1 }" [innerHTML]="'register_intro' | translate"></p>
          </div>
        </div>
        <div class="col-12 col-lg-9 py-3 col-registration-main">
          <ng-container *ngIf="registrationStep === 1">
            <div class="row mb-2">
              <div class="col-12 col-lg-6 order-2 text-lg-right">
                <p [innerHTML]="'register_already_registered' | translate"></p>
              </div>
              <div class="col-12 col-lg-6 order-1">
                <h2 translate>register_welcome</h2>
              </div>
            </div>
            <form class="form" role="form" (ngSubmit)="register()" [formGroup]="registerForm">
              <div class="row py-3">
                <div class="col-12 col-lg-6 ">
                  <div class="form-group">
                    <label for="username" translate>register_label_nation</label>
                    <ng-select
                      *ngIf="nations"
                      id="language"
                      bindValue="value"
                      formControlName="nat"
                      [items]="nations"
                      bindLabel="label"
                      [clearable]="false"
                      class="form-control"
                    >
                    </ng-select>
                    <wsb-validation-error-msg [fc]="registerForm.get('nat')"></wsb-validation-error-msg>
                  </div>
                  <div class="form-group">
                    <label for="firstname" translate>account_name</label>
                    <input type="text" class="form-control" name="firstname" id="firstname" formControlName="firstname" />
                    <wsb-validation-error-msg [fc]="registerForm.get('firstname')"></wsb-validation-error-msg>
                  </div>
                  <div class="form-group">
                    <label for="lastname" translate>account_surname</label>
                    <input type="text" class="form-control" name="lastname" id="lastname" formControlName="lastname" />
                    <wsb-validation-error-msg [fc]="registerForm.get('lastname')"></wsb-validation-error-msg>
                  </div>
                  <div class="form-group">
                    <label for="email" translate>account_username</label>
                    <input type="email" class="form-control" name="email" id="email" formControlName="email" />
                    <wsb-validation-error-msg [fc]="registerForm.get('email')"></wsb-validation-error-msg>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="form-group" *ngIf="registerForm.get('nat').value === 'ita'">
                    <label translate>register_label_type</label><br />
                    <label>
                      <input type="radio" name="accountType" formControlName="accountType" value="COMPANY" checked="checked" />
                      <span class="radio-custom__label  ms-2 me-4" translate>account_company</span>
                    </label>
                    <label>
                      <input type="radio" name="accountType" formControlName="accountType" value="PUBLIC_ADMINISTRATION" />
                      <span class="radio-custom__label  ms-2 me-4" translate>account_pa</span>
                    </label>
                    <wsb-validation-error-msg [fc]="registerForm.get('accountType')"></wsb-validation-error-msg>
                  </div>
                  <div class="form-group">
                    <label for="company" *ngIf="registerForm.get('accountType').value !== 'PUBLIC_ADMINISTRATION'" translate
                      >register_label_company</label
                    >
                    <label for="company" *ngIf="registerForm.get('accountType').value === 'PUBLIC_ADMINISTRATION'" translate
                      >register_label_company_pa</label
                    >
                    <input type="text" class="form-control" name="company" id="company" formControlName="company" />
                    <wsb-validation-error-msg [fc]="registerForm.get('company')"></wsb-validation-error-msg>
                  </div>
                  <!-- <div class="form-group">
                    <label for="username" translate>account_username</label>
                    <input type="text" class="form-control" name="username" id="username"
                           formControlName="username">
                    <wsb-validation-error-msg [fc]="registerForm.get('username')"></wsb-validation-error-msg>
                  </div> -->
                  <div class="form-group password-line">
                    <label for="username" translate>account_password</label>
                    <input
                      [type]="showPassword ? 'text' : 'password'"
                      class="form-control"
                      name="password"
                      id="password"
                      formControlName="password"
                    />
                    <wsb-atlas-button
                      variant="icon"
                      [icon]="faPasswordIconShow"
                      roundButton=""
                      size="sm"
                      noHover="true"
                      (click)="showHidePassWord()"
                    >
                    </wsb-atlas-button>

                    <wsb-validation-error-msg [fc]="registerForm.get('password')"></wsb-validation-error-msg>
                  </div>
                  <div class="form-group password-line">
                    <label for="passwordConfirm" translate>register_label_passwordconfirm</label>
                    <input
                      [type]="showPasswordConfirm ? 'text' : 'password'"
                      class="form-control"
                      name="passwordConfirm"
                      id="passwordConfirm"
                      formControlName="passwordConfirm"
                    />
                    <wsb-atlas-button
                      variant="icon"
                      [icon]="faPasswordConfirmIconShow"
                      roundButton=""
                      size="sm"
                      noHover="true"
                      (click)="showHidePassWordConfirm()"
                    >
                    </wsb-atlas-button>

                    <wsb-validation-error-msg [fc]="registerForm.get('passwordConfirm')"></wsb-validation-error-msg>
                  </div>
                  <div class="form-group" *ngIf="isBuying">
                    <label for="taxcode" translate>account_cf</label>
                    <input type="text" class="form-control" name="taxcode" id="taxcode" formControlName="taxcode" />
                    <wsb-validation-error-msg [fc]="registerForm.get('taxcode')"></wsb-validation-error-msg>
                  </div>
                </div>
              </div>
              <div class="row py-3">
                <div class="col-12 col-lg-8">
                  <div class="form-check">
                    <label class="form-check-label" for="checkConditions1">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="checkConditions1"
                        id="checkConditions1"
                        formControlName="checkConditions1"
                      />
                      <span [innerHtml]="'check_terms' | translate"></span>
                      <wsb-validation-error-msg [fc]="registerForm.get('checkConditions1')"></wsb-validation-error-msg>
                    </label>
                  </div>
                  <div class="form-check" *ngIf="hasCheckConditions2">
                    <label class="form-check-label" for="checkConditions2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="checkConditions2"
                        id="checkConditions2"
                        formControlName="checkConditions2"
                      />
                      <span [innerHtml]="'register_check_terms_2' | translate"></span>
                      <wsb-validation-error-msg [fc]="registerForm.get('checkConditions2')"></wsb-validation-error-msg>
                    </label>
                  </div>
                  <div class="form-check" *ngIf="hasCheckPrivacy">
                    <label class="form-check-label" for="checkPrivacy">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="checkPrivacy"
                        id="checkPrivacy"
                        formControlName="checkPrivacy"
                      />
                      <span [innerHtml]="'check_privacy' | translate"></span>
                      <wsb-validation-error-msg [fc]="registerForm.get('checkPrivacy')"></wsb-validation-error-msg>
                    </label>
                  </div>
                  <div class="form-check">
                    <label class="form-check-label" for="checkMarketing">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="checkMarketing"
                        id="checkMarketing"
                        formControlName="checkMarketing"
                      />
                      <span [innerHtml]="'register_check_marketing' | translate"></span>
                      <wsb-validation-error-msg [fc]="registerForm.get('checkMarketing')"></wsb-validation-error-msg>
                    </label>
                  </div>
                </div>
                <div class="col-12 col-lg-4">
                  <wsb-atlas-button
                    class="d-block mt-3 mt-lg-0"
                    [loading]="loadingStep1"
                    [label]="'register_create_account'"
                    [roundButton]="true"
                    buttonType="submit"
                    [disabled]="disableSubmit()"
                  ></wsb-atlas-button>
                </div>
              </div>
            </form>
          </ng-container>
          <ng-container *ngIf="registrationStep === 2 || registrationStep === 3">
            <div class="row mb-2">
              <div class="col-12 col-lg-12">
                <h2 translate>register_verifynumber_title</h2>
              </div>
            </div>
            <div class="" *ngIf="registrationStep >= 2" [style.opacity]="registrationStep === 3 ? 0.5 : 1">
              <form class="form row" role="form" (ngSubmit)="verifyNumber()" [formGroup]="verifyNumberForm">
                <div class="col-12 col-sm-12">
                  <label class="d-lg-block" for="phoneNumber" translate>register_label_number</label>
                  <div class="d-lg-inline-block me-lg-3 mb-2">
                    <wsb-atlas-inputphone
                      id="phoneNumber"
                      name="phoneNumber"
                      [cssClass]="'form-control'"
                      [formControlName]="'phoneNumber'"
                      [checkUserPreferences]="false"
                      [mainNation]="mainNation"
                      #inputPhone
                      [readonly]="registrationStep === 3"
                    ></wsb-atlas-inputphone>
                  </div>
                  <div class="d-lg-inline-block me-lg-3 mb-2">
                    <wsb-atlas-button
                      class="d-block"
                      [loading]="loadingStep2"
                      [label]="'register_send_code'"
                      [roundButton]="true"
                      [disabled]="registrationStep === 3 || verifyNumberForm.invalid || inputPhone.phoneNumber.invalid"
                      buttonType="submit"
                    ></wsb-atlas-button>
                  </div>
                  <div class="d-lg-inline-block me-lg-3 mb-2">
                    <p *ngIf="otpSent && otpSendTries >= 1" translate>register_sent_code</p>
                  </div>
                  <div class="d-lg-inline-block me-lg-3 mb-2" *ngIf="otpSent && otpSendTries > 1">
                    <p>
                      <small><span translate>register_send_attempt</span> {{ otpSendTries }}</small>
                    </p>
                  </div>
                  <wsb-validation-error-msg
                    customMsg="{{ 'common_error' | translate }}"
                    [fc]="inputPhone.phoneNumber"
                  ></wsb-validation-error-msg>
                </div>
              </form>
            </div>
            <div class="mt-3" *ngIf="registrationStep === 3">
              <form class="form row" role="form" (ngSubmit)="verifyCode()" [formGroup]="verifyCodeForm">
                <div class="col-12 col-sm-12">
                  <label class="d-block" for="verifyCode" translate>register_label_smscode</label>
                  <div class="d-inline-block me-3  mb-2">
                    <input
                      type="text"
                      class="form-control"
                      name="verifyCode"
                      id="verifyCode"
                      placeholder="{{ 'register_label_smscode' | translate }}"
                      formControlName="verifyCode"
                    />
                  </div>
                  <div class="d-inline-block  mb-2">
                    <wsb-atlas-button
                      class="d-block"
                      [loading]="loadingStep3"
                      [label]="'register_validate_proceed'"
                      [roundButton]="true"
                      buttonType="submit"
                    ></wsb-atlas-button>
                  </div>
                  <div class="mt-2  mb-2">
                    <p *ngIf="codeValid" translate>register_code_valid</p>
                    <p class="text-danger d-lg-none" *ngIf="codeInvalid" translate>register_code_invalid</p>
                  </div>
                  <wsb-validation-error-msg [fc]="verifyCodeForm.get('verifyCode')"></wsb-validation-error-msg>
                </div>
              </form>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <ng-container *ngIf="registrationStep === 3">
                  <p [innerHTML]="'register_code_notreceived' | translate"></p>
                  <p
                    [innerHTML]="'register_code_notreceivedactions' | translate"
                    *ngIf="otpSendTries >= 1 && otpSendTries < maxOtpSent"
                  ></p>
                  <p [innerHTML]="'register_attempts_finished' | translate" *ngIf="otpSendTries >= maxOtpSent"></p>
                  <p [innerHTML]="'register_problems_contact' | translate"></p>
                </ng-container>
                <p *ngIf="!otpSendTries" [innerHTML]="'register_verifynumber_info' | translate"></p>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
